import { t } from 'i18next';
import * as Yup from 'yup';

import './_yup.extensions';

import { CUSTOMER_NUMBER_REGEX } from 'settings/regex';

export const validationSchema = Yup.object().shape({
  surname: Yup.string()
    .required(t('LABEL_ERROR_SURNAME_REQUIRED'))
    .matches(/^[^&]*$/, t('LABEL_ERROR_CARAC')),
  nClient: Yup.string()
    .required(t('LABEL_CUSTOMER_NUMBER_REQUIRED'))
    .matches(CUSTOMER_NUMBER_REGEX, t('LABEL_WRONG_ID_CLIENT'))
    .matches(/^[^&]*$/, t('LABEL_ERROR_CARAC')),
  turnstileToken: Yup.string().turnstileRequired(
    t('FORM_TURNSTILE_REQUIRED_ERROR', { ns: 'translation' })
  ),
});
